var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"black-friday-more-deals",class:{'black-friday-more-deals--centered': _vm.centered}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"black-friday-more-deals__content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }